// extracted by css-extract-rspack-plugin
export default {"wrapper":"_12e0a2c9","title":"_9f691c7a"};